import React, { useEffect, useState } from 'react';
import {
  Button,
  Card,
  CardContent,
  CardHeader,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import CreatePurchaseOrderNoteModal from 'src/components/PurchaseOrderDetails/modals/CreatePurchaseOrderNoteModal';
import PurchaseOrderNoteTable from 'src/components/PurchaseOrderDetails/tables/PurchaseOrderNoteTable';

const useStyles = makeStyles((theme) => ({
  card: {
    marginBottom: theme.spacing(2),
  },
  fontWeightMedium: {
    fontWeight: theme.typography.fontWeightMedium,
  },
  cardHeader: {
    color: theme.palette.secondary.main,
  },
}));

function NotesInfo({ poNumber, dispatchId, isAddNoteButtonDisabled }) {
  const classes = useStyles();
  const [openDialog, setOpenDialog] = useState(false);
  const [refreshTable, setRefreshTable] = useState(false);

  useEffect(() => {
    if (openDialog) {
      setRefreshTable(false);
    }
  }, [openDialog]);

  return (
    <>
      <CreatePurchaseOrderNoteModal isDialogOpen={openDialog} setIsDialogOpen={setOpenDialog} poNumber={poNumber} dispatchId={dispatchId} onSuccess={() => setRefreshTable(true)} />
      <Card className={classes.card}>
        <CardHeader
          className={classes.cardHeader}
          title="Notes"
          action={
            <Button
              disabled={isAddNoteButtonDisabled}
              variant='contained'
              color='primary'
              onClick={() => setOpenDialog(!openDialog)}
            >
              Add a Note
            </Button>}
        />
        <CardContent>
          {(poNumber && dispatchId) && <PurchaseOrderNoteTable dispatchId={dispatchId} poNumber={poNumber} refreshTable={refreshTable} />}
        </CardContent>
      </Card>
    </>
  );
}

NotesInfo.propTypes = {
  poNumber: PropTypes.string.isRequired,
  dispatchId: PropTypes.string.isRequired,
  isAddNoteButtonDisabled: PropTypes.bool
};

NotesInfo.defaultProps = {
  isAddNoteButtonDisabled: false
};

export default NotesInfo;
